import { useIntl, defineMessages } from 'dibs-react-intl';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Input } from 'dibs-elements/exports/Input.tsx';
import { Link } from 'dibs-elements/exports/Link.tsx';
import SearchIconLegacy from 'dibs-icons/exports/legacy/MagnifyingGlass.ts';
import SearchIcon from 'dibs-icons/exports/Search.ts';

import dibsCss from 'dibs-css';
import styles from './SbSharedRefineMenuSearchInput.scss';

const messages = defineMessages({
    buttonLabel: {
        id: 'sb.SbSharedRefineMenuSearchInput.buttonLabel',
        defaultMessage: 'Search',
    },
    formLabel: {
        id: 'sb.SbSharedRefineMenuSearchInput.formLabel',
        defaultMessage: `{filterName, select,
        creator {Creator}
        location {Locations}
        material {Materials}
        metal {Metals}
        origin {Places}
        stone {Stones}
        stonecut {Stone Cuts}
        other {}
    }`,
    },
});

export function SbSharedRefineMenuSearchInput(props) {
    const {
        autoComplete = 'off',
        className,
        horizontalSpacing = 'medium',
        onInput,
        onSubmit,
        placeholder,
        size = 'medium',
        value,
        ariaControls,
        filterName = '',
        onBlur,
        onFocus,
        disabled,
        isQuickFiltersRedesignVariant,
    } = props;
    const intl = useIntl();
    const containerClass = classnames(className);
    return (
        <div className={containerClass}>
            <form
                onSubmit={onSubmit}
                role="search"
                aria-label={intl.formatMessage(messages.formLabel, {
                    filterName: filterName.replace('-', ''),
                })}
                action=""
                data-tn="refine-menu-select-input-form"
            >
                <Input
                    ariaControls={ariaControls}
                    onBlur={onBlur}
                    onFocus={onFocus}
                    type="search"
                    autoComplete={autoComplete}
                    autoCorrect={false}
                    dataTn="search-input"
                    disabled={disabled}
                    horizontalSpacing={horizontalSpacing}
                    onChange={onInput}
                    placeholder={placeholder}
                    size={size}
                    spellCheck={false}
                    value={value}
                    rightDecorator={
                        <Link
                            className={styles.searchIconWrapper}
                            ariaLabel={intl.formatMessage(messages.buttonLabel)}
                            onClick={onSubmit}
                        >
                            {isQuickFiltersRedesignVariant ? (
                                <span className={disabled && dibsCss.fillIron}>
                                    <SearchIcon variation="24" />
                                </span>
                            ) : (
                                <SearchIconLegacy className={disabled && dibsCss.textIron} />
                            )}
                        </Link>
                    }
                />
            </form>
        </div>
    );
}

SbSharedRefineMenuSearchInput.propTypes = {
    autoComplete: PropTypes.string,
    className: PropTypes.string,
    horizontalSpacing: PropTypes.oneOf(['small', 'medium']),
    onInput: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    placeholder: PropTypes.string.isRequired,
    size: PropTypes.oneOf(['medium', 'large']),
    value: PropTypes.string.isRequired,
    ariaControls: PropTypes.string,
    filterName: PropTypes.string,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    disabled: PropTypes.bool,
    isQuickFiltersRedesignVariant: PropTypes.bool,
};
